/**
 * PasswordStrengthBars — four-bar indicator showing password strength level.
 * Used by RegisterPage and ResetPasswordForm.
 *
 * @param score — 0–5 strength score (0–4 bars fill, 5 = all filled)
 * @param className — optional additional classes
 */
import { type StrengthScore, strengthColors } from "@/shared/lib/design-tokens";
import { cn } from "@/shared/lib/utils";

interface PasswordStrengthBarsProps {
  score: StrengthScore;
  className?: string;
}

export function PasswordStrengthBars({ score, className }: PasswordStrengthBarsProps) {
  return (
    <div className={cn("flex gap-1 flex-1", className)}>
      {[1, 2, 3, 4].map((level) => (
        <div
          key={level}
          className="h-0.5 flex-1 rounded-full transition-all duration-300"
          style={{
            background:
              level <= score
                ? strengthColors[score] ?? strengthColors[4]
                : "var(--border)",
          }}
        />
      ))}
    </div>
  );
}